import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { usePackageEmployeePerformance } from "@/hooks/usePackageEmployeePerformance";
import { Trophy, User, DollarSign, Star } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export const EmployeePackagePerformanceWidget = () => {
  const { data: performance, isLoading } = usePackageEmployeePerformance();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-64 w-full" />
        </CardContent>
      </Card>
    );
  }

  const topEmployees = performance?.slice(0, 5) || [];

  return (
    <Card className="border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Trophy className="w-5 h-5 text-purple-600" />
          أداء الموظفين - الباقات السياحية
        </CardTitle>
        <CardDescription>ترتيب الموظفين حسب مبيعات الباقات</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="text-right">الترتيب</TableHead>
              <TableHead className="text-right">الموظف</TableHead>
              <TableHead className="text-right">الحجوزات</TableHead>
              <TableHead className="text-right">الإيرادات</TableHead>
              <TableHead className="text-right">العمولة</TableHead>
              <TableHead className="text-right">التقييم</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {topEmployees.map((emp) => (
              <TableRow key={emp.employeeId} className="hover:bg-white/50">
                <TableCell>
                  <div className="flex items-center gap-2">
                    {emp.rank === 1 && <Trophy className="w-5 h-5 text-yellow-500" />}
                    {emp.rank === 2 && <Trophy className="w-5 h-5 text-gray-400" />}
                    {emp.rank === 3 && <Trophy className="w-5 h-5 text-orange-500" />}
                    <span className="font-semibold">{emp.rank}</span>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <User className="w-4 h-4 text-muted-foreground" />
                    <span className="font-medium">{emp.employeeName}</span>
                  </div>
                </TableCell>
                <TableCell>
                  <Badge variant="outline" className="bg-blue-50">
                    {emp.totalPackagesSold} باقة
                  </Badge>
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1 text-green-600 font-semibold">
                    <DollarSign className="w-4 h-4" />
                    {emp.totalRevenue.toLocaleString()}
                  </div>
                </TableCell>
                <TableCell className="text-amber-600 font-medium">
                  {emp.commission.toLocaleString()} ريال
                </TableCell>
                <TableCell>
                  <div className="flex items-center gap-1">
                    <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                    <span className="font-medium">{emp.averageRating.toFixed(1)}</span>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {topEmployees.length === 0 && (
          <div className="text-center py-8 text-muted-foreground">
            <User className="w-12 h-12 mx-auto mb-2 opacity-50" />
            <p>لا توجد بيانات أداء متاحة حالياً</p>
          </div>
        )}
      </CardContent>
    </Card>
  );
};
